const numberOrSpecialCharacterPattern = /.*[0-9!@#$%^&*()].*/; // checks if string contains number or special character

export function passContainNumberOrSpecialCharacter(pass: string) {
  return numberOrSpecialCharacterPattern.test(pass);
}
